import { LABELS } from "~/resources/Labels";
import { SIMPLDialog } from "../../components/commons/dialog/SimplDialog";
import { getCloudProviderName } from "~/Utils/Utils";
import { FormCloudEnvironmentResponse } from "~/models/Commons ";
import { DetailRow } from "../DetailsRow/DetailsRow";
import { useTranslation } from "react-i18next";

interface DetailProps {
  item: FormCloudEnvironmentResponse;
  onClose: () => void;
}

export const DetailViewCloudEnvironment = ({
  item,
  onClose,
}: DetailProps) => {
  const { t } = useTranslation();
  return (
    <SIMPLDialog onCloseModal={onClose} title={t("DetailView")}>
      <div className="w-auto p-2 pb-5 flex flex-col">
        <DetailRow label={t("Name")} value={item.environmentName} />
        <DetailRow label={t("Description")} value={item.environmentDescription} />
        <DetailRow label={t("DataCenterName")} value={item.datacenterName} />
        <DetailRow label={t("DataCenterDescription")} value={item.datacenterDescription} />
        <DetailRow label={t("Provider")} value={getCloudProviderName(item.cloudProvider)} />
        <DetailRow label={t("Location")} value={item.location} />
        <DetailRow label={t("Iac")}   value={item.iac} className="truncate" />
      </div>
    </SIMPLDialog>
  );
};